module.exports = __webpack_public_path__ + "img/mapSearch.b568823c.png";